// extracted by mini-css-extract-plugin
export default {"rating":"py-z","numberOfStars":"qy-z","count":"ry-z","barGraphSpacing":"sy-z","barGraph":"ty-z"};